import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

import "./styles/main.scss";
import "antd/dist/antd.css";
import {
  LoginScreen,
  RegisterVaccineScreen,
  ManageRegisterVaccination,
  NotifyRegisterVaccineNormal,
  NotifyRegisterVaccineSpecial,
  RegisterUserScreen,
  ForgotPasswordScreen,
  ChangePasswordScreen,
  RegisterVaccineScreenV2,
} from "./router/index";
import React, { Suspense } from "react";
import { Spin } from "antd";
import { NotFound } from "./components";

function App() {
  return (
    <>
      <Suspense
        fallback={
          <div className="loading">
            <Spin size="large"></Spin>
          </div>
        }
      >
        <Router>
          <Switch>
            <Redirect exact from="/" to="/register-vaccine" />

            <Route
              exact
              path="/register-vaccine"
              component={RegisterVaccineScreen}
            />
            <Route
              exact
              path="/register-vaccine-v2"
              component={RegisterVaccineScreenV2}
            />
            <Route
              path="/register-normal/notify"
              component={NotifyRegisterVaccineNormal}
            />
            <Route
              path="/register-special/notify"
              component={NotifyRegisterVaccineSpecial}
            />

            <Route path="/login" component={LoginScreen} />
            <Route exact path="/register" component={RegisterUserScreen} />
            <Route
              exact
              path="/register/:idUser"
              component={RegisterUserScreen}
            />
            <Route path="/forgot-password" component={ForgotPasswordScreen} />
            <Route path="/change-password" component={ChangePasswordScreen} />
            <Route
              path="/manage-register"
              component={ManageRegisterVaccination}
            />

            <Route component={NotFound} />
          </Switch>
        </Router>
      </Suspense>
    </>
  );
}

export default App;
